export const subtotalSectionTestIds = {
  subtotal: 'discount-panel-subtotal',
};
